import {
  SessionClaimsPanel,
  TaskDodSection,
  TaskEvidenceArtifactSection,
} from "@excellent/ui";
import { useApi } from "@excellent/ui/api";
import { dod } from "@excellent/ui/api/contracts/dod";
import { sessions } from "@excellent/ui/api/contracts/sessions";
import { tasks } from "@excellent/ui/api/contracts/tasks";

/** Task-only proof depth for the persistent Inspector pane. */
export function TaskInspectorProof({ taskId }: { taskId: number }) {
  const evidence = useApi(tasks.evidenceArtifact, { params: { id: taskId } });
  const definition = useApi(dod.task, { params: { id: taskId } });
  const claims = useApi(sessions.claims, { query: { task_id: taskId } });
  const unavailable = evidence.error || definition.error || claims.error;
  const loading =
    (evidence.isLoading && !evidence.data) ||
    (definition.isLoading && !definition.data) ||
    (claims.isLoading && !claims.data);

  return (
    <details
      className="vp-inspector-technical"
      data-task-inspector-proof=""
      data-task-id={taskId}
    >
      <summary>Task proof</summary>
      <div
        className="flex flex-col gap-6 pt-4"
        data-task-inspector-proof-content=""
        aria-busy={loading || undefined}
      >
        {unavailable ? (
          <p role="status">Task proof is unavailable. Existing proof could not be checked.</p>
        ) : loading ? (
          <p role="status">Loading task proof</p>
        ) : (
          <>
            <TaskEvidenceArtifactSection taskId={taskId} />
            <TaskDodSection taskId={taskId} />
            <SessionClaimsPanel taskId={taskId} />
          </>
        )}
      </div>
    </details>
  );
}
